<template>
  <!-- Content Header (Page header) -->
  <div v-if="isAuthenticated" class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="m-0">{{ currentPage }}</h1>
        </div>
        <!-- /.col -->
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item">
              <router-link to="/">Home</router-link>
            </li>
            <li class="breadcrumb-item active">{{ currentPage }}</li>
          </ol>
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->
</template>

<script>
export default {
  computed: {
    isAuthenticated() {
      return this.$store.getters['users/isAuthenticated'];
    },
    currentPage() {
      return this.$store.getters['options/getCurrentPage'];
    },
  },
};
</script>

<style></style>
